import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { WebSocketService } from '../services';

import { ConnectionStateColor } from './constants';

@Component({
  selector: 'app-internal-messenger-connection-state',
  templateUrl: './connection-state.component.html',
  styleUrls: ['./connection-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectionStateComponent {
  readonly wss = inject(WebSocketService);

  colors = ConnectionStateColor;
}
